import React from 'react';

const EmergencyRepairSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            故障・墜落時も迅速サポート
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            ドローンの故障や墜落は予期せず発生します。IDS教習所グループでは、佐賀・川副・鹿児島の3拠点が連携し、緊急時にも迅速に対応できる体制を整えています。
          </p>
        </div>

        <div className="mb-12">
          <h3 className="text-2xl font-semibold text-gray-900 text-center mb-8">
            グループ連携体制の3つの強み
          </h3>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-share-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-3">1. 部品共有ネットワーク</h4>
              <p className="text-gray-600">
                3拠点間で修理部品を共有することで、在庫状況に応じた最速の対応が可能です。一つの拠点に部品がなくても、他拠点から迅速に調達し、お客様の待ち時間を最小限に抑えます。
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-search-line text-2xl text-green-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-3">2. 迅速な診断</h4>
              <p className="text-gray-600">
                DJI認定整備士が、故障の原因を素早く特定します。飛行データの解析や、DJI修理マニュアルに基づく診断により、的確な修理方針を立てます。修理見積もりは無料です。
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-flight-takeoff-line text-2xl text-orange-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-3">3. 代替機のご相談</h4>
              <p className="text-gray-600">
                修理期間中も業務を止められないお客様のために、代替機のご用意についてもご相談を承ります（在庫状況による）。散布シーズンなど繁忙期も安心してお任せください。
              </p>
            </div>
          </div>
        </div>

        <div className="bg-orange-50 border border-orange-200 rounded-lg p-6">
          <div className="flex items-start">
            <i className="ri-alert-line text-orange-600 mr-3 mt-1"></i>
            <div>
              <p className="text-gray-700">
                ※故障の内容、部品の在庫状況、修理の混雑状況によっては、即時対応できない場合もございます。まずはお気軽に各拠点へお電話またはお問い合わせフォームからご相談ください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmergencyRepairSection;